import React, { useState, useCallback } from 'react'
import { compose } from 'recompose'
import { withHooks } from '../../../../../enhancers'
import CollapseComponent from './CollapseComponent'

const SetupPremium = props => (
  <div>
    <div className="d-flex justify-content-between p-b-10">
      <div className="f-s-20 f-w-700">Premium</div>
      <button type="button" className="btn btn-success" onClick={props.onAdd}>
        Add
      </button>
    </div>
    {props.form.values.premiumMasters &&
      props.form.values.premiumMasters.map((field, index) => (
        <CollapseComponent
          {...props}
          field={`premiumMasters[${index}]`}
          key={field + index}
          index={index}
          configs={props.configs}
          isHealth={props.isHealth}
          remove={props.remove}
          values={field}
        />
      ))}
  </div>
)

const enhancer = compose(
  withHooks(props => {
    const [loading, setLoading] = useState(false)
    const onAdd = useCallback(() => {
      props.push({})
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return {
      loading,
      setLoading,
      onAdd,
    }
  })
)

export default enhancer(SetupPremium)
